import { render } from "./PrototypeComponent.vue?vue&type=template&id=684f38d2&scoped=true&ts=true"
import script from "./PrototypeComponent.vue?vue&type=script&lang=ts"
export * from "./PrototypeComponent.vue?vue&type=script&lang=ts"

import "./PrototypeComponent.vue?vue&type=style&index=0&id=684f38d2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-684f38d2"]])

export default __exports__